import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FieldsService} from '../../../core/fields/fields.service';
import {FieldType} from '../../../models/fieldType';

@Component({
  selector: 'app-fields',
  templateUrl: './fields.component.html',
  styleUrls: ['./fields.component.scss']
})
export class FieldsComponent implements OnInit {

  fieldForm: FormGroup;

  fields: any[];

  fieldTypes = Object.keys(FieldType);

  sortOptions = {
    animation: 150,
    handle: '.handle',
    onEnd: () => {
      this.fields.forEach(field => {
        field.order = this.fields.indexOf(field);
      });
      this.fieldsService.massEdit(this.fields)
        .subscribe(() => {});
    }
  };

  constructor(private fb: FormBuilder, private fieldsService: FieldsService) { }

  ngOnInit() {
    this.fieldForm = this.fb.group({
      name: ['', Validators.required],
      type: ['', Validators.required]
    });

    this.getFields();
  }

  getFields() {
    this.fieldsService.list()
      .subscribe((fields: any[]) => {
        this.fields = fields;
      }, (err) => {
        alert(err.error.message || 'An error occurred');
      });
  }

  createField(field) {
    field.order = this.fields.length;
    this.fieldsService.create(field)
      .subscribe((newField: any) => {
        this.getFields();
        this.fieldForm.reset();
      }, (err) => {
        alert(err.error.message || 'An error occurred');
      });
  }

  toggleFilterable(field) {
    this.fieldsService.edit(field._id, {filterable: !field.filterable})
      .subscribe((editedField: any) => {
        this.fields = this.fields.map(f => {
          if (f._id === editedField._id) {
            return editedField;
          } else {
            return f;
          }
        });
      }, err => {
        alert(err.error.message);
      });
  }

  deleteField(field) {
    const id = field._id;
    this.fieldsService.delete(id)
      .subscribe(() => {
        this.fields = this.fields.filter(f => f._id !== id);
      }, err => {
        alert(err.error.message || 'An error occurred');
      });
  }

}



// WEBPACK FOOTER //
// ./client/app/components/settings/fields/fields.component.ts